import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { LandingResumeDemo } from '@/components/landing/demos/LandingResumeDemo';
import { LandingInterviewDemo } from '@/components/landing/demos/LandingInterviewDemo';
import { LandingPipelineDemo } from '@/components/landing/demos/LandingPipelineDemo';
import { LandingWorkStyleDemo } from '@/components/landing/demos/LandingWorkStyleDemo';
import { ArrowRight } from 'lucide-react';

const DEMO_MAP: Record<string, { component: React.FC; label: string; link: string }> = {
  'resume-screening': {
    component: LandingResumeDemo,
    label: 'AI Resume Screening',
    link: '/resume-screening',
  },
  'ai-interviews': {
    component: LandingInterviewDemo,
    label: 'AI Video Interviews',
    link: '/ai-interviews',
  },
  pipeline: {
    component: LandingPipelineDemo,
    label: 'Hiring Pipeline',
    link: '/features',
  },
  'work-style': {
    component: LandingWorkStyleDemo,
    label: 'Work Style Assessment',
    link: '/work-style-assessment',
  },
};

interface BlogInlineDemoProps {
  demoKey: string;
}

export function BlogInlineDemo({ demoKey }: BlogInlineDemoProps) {
  const entry = DEMO_MAP[demoKey];
  if (!entry) return null;

  const DemoComponent = entry.component;

  return (
    <div className="my-10 not-prose">
      <Card className="border-primary/20 bg-primary/[0.02] overflow-hidden">
        <CardContent className="p-6 md:p-8">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs font-semibold uppercase tracking-wider text-primary">
              See It in Action
            </span>
          </div>
          <h3 className="text-lg font-bold text-foreground mb-4">
            {entry.label} — Interactive Demo
          </h3>
          <div className="rounded-xl border border-border bg-card p-4 md:p-6 mb-5">
            <DemoComponent />
          </div>
          <Link
            to={entry.link}
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary hover:text-primary/80 transition-colors"
          >
            Learn more about {entry.label}
            <ArrowRight className="h-4 w-4" />
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
